import { Typography } from '@material-ui/core';
import React, { PropsWithChildren } from 'react';

interface BodyDetailsProps extends PropsWithChildren<{ className?: string }> {
  'data-test'?: string;
  className?: string;
  style?: React.CSSProperties;
}

const BodyDetails: React.FC<BodyDetailsProps> = ({ className, children, style, 'data-test': dataTest }) => (
  <Typography component="span" className={className} style={style} variant="body2" data-test={dataTest}>
    {children}
  </Typography>
);

export default BodyDetails;
